module.exports = "<div id=\"hubspotForm\" class=\"hubspot-form-align\"></div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/feature/external/hub-spot-form/hub-spot-form.component.html
// module id = ./src/app/feature/external/hub-spot-form/hub-spot-form.component.html
// module chunks = main